module.exports = __webpack_public_path__ + "static/img/创青春三等奖.ebbea237.jpg";